export const UPDATE_FIELD = 'UPDATE_FIELD';
export const SUBMIT = 'SUBMIT';
export const SEARCH = 'SEARCH';
export const SHOW_MODAL = 'SHOW_MODAL';